import PropTypes from 'prop-types';

// import RightSideBarAds from './RightSideBarAds';
import Box from '../components/layout/Box';
import ContentHandler from './ContentHandler';
import MainContentContainer from './MainContentContainer';
import ScrollContainer from './ScrollContainer';
import Footer from './Footer';

const CollaborationPage = ({
  className,
  children,
  error,
  loading,
  onRetry,
  ...other
}) => {
  return (
    <ScrollContainer>
      <MainContentContainer>
        <Box
          className={`flex-grow-1 justify-content-center ${className}`}
          {...other}
        >
          <ContentHandler
            error={error}
            onRetry={onRetry}
            loading={loading}
            className="w-100 flex-column pb-5"
            style={{ maxWidth: 940 }}
          >
            {children}
          </ContentHandler>
        </Box>
      </MainContentContainer>

      <Footer />
    </ScrollContainer>
  );
};

CollaborationPage.defaultProps = {
  className: '',
  onRetry: undefined,
  error: undefined,
  loading: false,
};

CollaborationPage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  onRetry: PropTypes.func,
};

export default CollaborationPage;
